// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"productBuying_pageContainer__8YTx0","ProductBuyingHeader":"productBuying_ProductBuyingHeader__1Rxd0","statesHeader":"productBuying_statesHeader__3F6oX"};